'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'stroopwafel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f551';
var svgPathData = 'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM142.9 120.2l45.3 45.3 45.3-45.3L210.7 97.6 199.4 86.3l22.6-22.6L233.4 75 256 97.6 278.6 75l11.3-11.3 22.6 22.6L301.3 97.6l-22.6 22.6 45.3 45.3 45.3-45.3 11.3-11.3 22.6 22.6-11.3 11.3-45.3 45.3 45.3 45.3 22.6-22.6 11.3-11.3 22.6 22.6L437 233.4 414.4 256 437 278.6l11.3 11.3-22.6 22.6-11.3-11.3-22.6-22.6-45.3 45.3 45.3 45.3 11.3 11.3-22.6 22.6-11.3-11.3-45.3-45.3-45.3 45.3 22.6 22.6 11.3 11.3-22.6 22.6L278.6 437 256 414.4 233.4 437l-11.3 11.3-22.6-22.6 11.3-11.3 22.6-22.6-45.3-45.3-45.3 45.3-11.3 11.3-22.6-22.6 11.3-11.3 45.3-45.3-45.3-45.3L97.6 301.3 86.3 312.6 63.7 289.9 75 278.6 97.6 256 75 233.4 63.7 222.1l22.6-22.6 11.3 11.3 22.6 22.6 45.3-45.3-45.3-45.3-11.3-11.3 22.6-22.6 11.3 11.3zm45.3 90.5L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zm181 45.3l-45.3-45.3L278.6 256l45.3 45.3L369.1 256zm-67.9 67.9L256 278.6l-45.3 45.3L256 369.1l45.3-45.3zM210.7 188.1L256 233.4l45.3-45.3L256 142.9l-45.3 45.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStroopwafel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;